module.exports = __webpack_public_path__ + "img/megafon.25738426.png";